/**
@format
@flow
*/
import React from 'react';
import Colors from '@ziynx/theme/colors';
import { InlineLink as KrispyInlineLink } from '@krispy/links/web';

type Props = $ReadOnly<{|
  /**
   * Text for the link.
   */
  children: any,

  /**
   * URL for the link.
   */
  href?: string,

  /**
   * Custom color for inlineLink
   */
  color?: string,

  /**
   * Function to be fire when link is clicked.
   */
  onClick?: (event?: SyntheticEvent<HTMLAnchorElement>) => any | Promise<any>,

  /**
   * Target for the link to open.
   */
   target?: string,
|}>;

const InlineLink = (props: Props): React$Node => {
  const {
    children, href, onClick, color, ...rest
  } = props;

  return (
    <KrispyInlineLink
      color={color}
      href={href}
      onClick={onClick}
      {...rest}
    >
      {children}
    </KrispyInlineLink>
  );
};

InlineLink.defaultProps = {
  color: Colors.PrimaryBlue,
};

export default InlineLink;
